import React from "react";
import classNames from "classnames";
import styles from "./NavigationButton.css";

export enum NavigationButtonStyleType {
  DYNAMIC_SUGGESTIONS = "dynamic_suggestions",
  CAROUSEL = "carousel"
}

export enum Direction {
  NEXT,
  PREVIOUS
}

interface Props {
  direction: Direction;
  navigationButtonStyle: NavigationButtonStyleType;
  hidden: boolean;
  onClick: () => void;
}

export const NavigationButton = ({ direction, navigationButtonStyle, hidden, onClick }: Props) => {
  return (
    <div
      className={classNames(
        styles["navigation-button"],
        styles[navigationButtonStyle],
        direction === Direction.NEXT ? styles.next : styles.previous,
        hidden && styles.hidden
      )}
      onClick={onClick}
    >
      &gt;
    </div>
  );
};
